/**
 * moBaoCaoTuDashboard — bấm tiêu đề widget báo cáo trên dashboard thì mở trang báo cáo gốc ĐÚNG như
 * đang thấy trên widget: cùng MẪU PIVOT (pivotconfig) và cùng ĐIỀU KIỆN LỌC đang hiển thị.
 *
 * Trước đây (22/10/2026): widget chỉ đẩy `state.condition` = điều kiện KHAI BÁO của widget. Trang báo cáo
 * thì (1) mở ở chế độ xem đã nhớ (bảng / thẻ…), không phải pivot; (2) chọn mẫu pivot dùng lần cuối hoặc mẫu
 * mới nhất, không phải mẫu của widget; (3) chỉ ĐIỀN SẴN điều kiện vào bộ lọc rồi chờ bấm "Xem" — và điều
 * kiện đó lại là điều kiện khai báo, không phải điều kiện widget đang chạy (đã qua giá trị mặc định động
 * như "tháng này", có thể khác).
 *
 * Nay widget đẩy thêm `state.tuDashboard = { viewMode:'pivot', pivotConfigId, condition }` với `condition`
 * là điều kiện ReportFrame của widget ĐANG ÁP DỤNG (ref.getCondition()). Trang báo cáo đọc lại bằng
 * `docTrangThaiMoBaoCao` và đưa vào ReportFrame:
 *   - initialViewMode      -> mở thẳng chế độ pivot (không ghi đè chế độ người dùng đã nhớ);
 *   - initialPivotConfigId -> DataPivotViewer chọn đúng mẫu này (ưu tiên hơn mẫu dùng lần cuối);
 *   - drillDownCondition   -> cơ chế SẴN CÓ của ReportFrame: điều kiện được áp dụng ngay, không chờ bấm.
 *
 * File KHÔNG import gì để test node chạy thẳng trên mã nguồn (packages/scripts/dashboard-mo-bao-cao-test.js).
 */

export const LOAI_WIDGET_BAO_CAO = ['pivot', 'report'];

const laObject = (v) => !!v && typeof v === 'object' && !Array.isArray(v);

/**
 * Trạng thái (history state) để mở trang báo cáo từ một widget.
 * @param {object} p
 * @param {string} p.type                 loại widget
 * @param {object} p.widgetConfig
 * @param {object} [p.dieuKienKhaiBao]     điều kiện khai báo (widgetConfig.condition + reportCondition) — giữ cho tương thích
 * @param {object} [p.dieuKienDangHien]    điều kiện ReportFrame của widget đang áp dụng (ref.getCondition())
 * @returns {{condition:object, tuDashboard?:object}}
 */
export const taoTrangThaiMoBaoCao = ({ type, widgetConfig = {}, dieuKienKhaiBao = {}, dieuKienDangHien = null }) => {
	const condition = laObject(dieuKienKhaiBao) ? dieuKienKhaiBao : {};
	if (!LOAI_WIDGET_BAO_CAO.includes(type)) return { condition };
	const tuDashboard = {
		viewMode: 'pivot',
		condition: laObject(dieuKienDangHien) ? dieuKienDangHien : condition,
	};
	if (type === 'pivot' && widgetConfig && widgetConfig.pivotConfigId) tuDashboard.pivotConfigId = String(widgetConfig.pivotConfigId);
	return { condition, tuDashboard };
};

/**
 * Đọc lại ở trang báo cáo. Không mở từ dashboard -> {} (trang chạy y như cũ).
 * @returns {{initialViewMode?:string, initialPivotConfigId?:string, drillDownCondition?:object}}
 */
export const docTrangThaiMoBaoCao = (locationState) => {
	const t = locationState && locationState.tuDashboard;
	if (!laObject(t)) return {};
	const kq = {};
	if (t.viewMode === 'pivot') kq.initialViewMode = 'pivot';
	if (t.pivotConfigId) kq.initialPivotConfigId = String(t.pivotConfigId);
	if (laObject(t.condition) && Object.keys(t.condition).length > 0) kq.drillDownCondition = t.condition;
	return kq;
};
